export class CFFileForSignatureOnGlass {
  constructor(
    public fileBase64: string,
    public fileName: string
) {}
} 